import { APPS } from "icons";
import { NavItem } from "@/components/nav/item";
import { NavSubItem } from "@/components/nav/sub-item";

export function AppsNavigations() {
  return (
    <NavItem title="Apps" url="/apps" icon={APPS} matchExact={true}>
      {/* <NavSubItem title="Meet" url="/apps/meet" /> */}
      <NavSubItem
        title="Pull Requests"
        url="/apps/pull-requests"
        requiredPermissions={{
          type: "collection",
          collection: "pull_requests",
        }}
      />
      <NavSubItem
        title="Resume Builder"
        url="https://resumes.everest.7span.work"
        target="__blank"
        external
      />
      <NavSubItem
        title="Portfolio"
        url="https://portfolio.everest.7span.work"
        target="__blank"
        external
      />
      <NavSubItem title="Email Signature" url="/apps/email-signature" />
      <NavSubItem title="Openings" url="/apps/openings" />
    </NavItem>
  );
}
